<template>
  <div class="kpi-recharge-page" v-if="true">
    <div class="title">
      <img :src="kpiAvatarUrl" />
      <div>{{kpiUserName}}</div>
    </div>
    <div class="tip">账号信息</div>
    <van-cell-group class="cell-group">
      <van-field v-model="kpiUserName" label="姓名" readonly />
      <van-field v-model="kpiUserBrand" label="品牌" readonly />
      <div class="tips bottom-line" v-if="true">提示：请核对您的身份信息所属品牌是否正确，如果不正确请联系活动负责人更改。</div>
    </van-cell-group>

    <div class="tip" v-if="kpiUserType=='brand'">品牌费用</div>
    <div class="tip" v-if="kpiUserType=='staff'">导购员奖金池</div>
    <van-cell-group class="cell-group">
      <div class="btn van-cell">
        <div v-if="kpiUserType=='staff'">
          导购员奖金池需要充值：
          <span class="amount">{{Number(this.staffBonus)}}元</span>
        </div>
        <div v-if="kpiUserType=='brand'">
          品牌费用总计：
          <span class="amount">{{brand_total_bonus}}元</span>
        </div>
        <van-button
          slot="button"
          round
          size="small"
          type="info"
          @click="createCharge"
          v-if="kpiUserType=='brand'"
        >充值</van-button>
        <van-button
          slot="button"
          round
          size="small"
          type="info"
          @click="createCharge"
          v-if="kpiUserType=='staff'"
        >充值</van-button>
      </div>
      <div v-if="kpiUserType=='brand'">
        <van-cell
          title="品牌奖励豆基金池："
          :value="Number(BrandDetail.brandBonusBean) + '元'"
          value-class="blue"
        />
        <van-cell
          title="导购员奖励豆基金池："
          :value="Number(BrandDetail.staffBonusBean) + '元'"
          value-class="blue"
        />
        <van-cell
          title="品牌惩罚承诺金："
          :value="Number(BrandDetail.brandPenalty) + '元'"
          value-class="blue"
        />
        <van-cell
          title="客户分享奖励"
          :value="Number(BrandDetail.userShareBonus) + '元'"
          value-class="blue"
        />
        <van-cell
          title="导购员单项奖励金"
          :value="Number(BrandDetail.staffSingleBonus) + '元'"
          value-class="blue"
        />
        <van-cell
          title="直播间红包："
          :value="Number(BrandDetail.liveRedPackage) + '元'"
          value-class="blue"
          class="bottom-line"
        />
        <van-cell
          title="推广费用："
          :value="Number(BrandDetail.otherPromotionExpenses) + '元'"
          value-class="blue"
        />
      </div>
      <div
        class="tips bottom-line"
        v-if="kpiUserType=='staff'"
      >提示：请充值导购员奖金池参与费用，如果不充值将不能完成考核任务和奖金的结算。</div>
      <div class="tips bottom-line" v-if="kpiUserType=='brand'">提示：请充值品牌费用，如果不充值将不能完成考核任务和奖金的结算。</div>
    </van-cell-group>

    <!-- <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { activity_id: activity.id, user_id: user_id, kpi_uid: kpi_uid, share_uid: share_uid }}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity: {},
      user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      kpi: {},
      user: null,
      live_user: null,
      role: "",
      brand_total_bonus: 0,
      nodata: "San",
      kpiUserType: "",
      BrandDetail: {
        brandBonusBean: 0,
        staffBonusBean: 0,
        brandPenalty: 0,
        userShareBonus: 0,
        staffSingleBonus: 0,
        liveRedPackage: 0,
        otherPromotionExpenses: 0,
      },
      brandList: [],
      staffBonus: 0,
      chargeDetail: {
        amount: 0, //充值金额（元）,当chargeUserType=finance时，需要传
        chargeUserType: "", //充值用户类型：staff：导购员，brand：品牌方，finance：财务
        type: "string", //充值类型,当chargeUserType=finance时，需要传。brand_bonus_bean：品牌奖励豆奖金池，staff_bonus_bean：导购员奖励豆奖金池，brand_penalty：品牌惩罚承诺金，user_share_bonus：客户分享奖励，staff_single_bonus：导购员单项奖励金，live_red_package：直播间红包，other_promotion_expenses：其他推广费用
      },
      kpiAvatarUrl: "https://j.weizan.cn/city/app/default-pic500.png",
      actName: "",
    };
  },
  created() {
    this.kpiUserType = localStorage.getItem("userType") || "brand"; //获取当前用户的用户类型，一般是brand和staff
    this.kpiAvatarUrl = localStorage.getItem("avatarUrl") || ""; //获取用户名
    this.kpiUserBrand = localStorage.getItem("kpiBrandName") || "暂无品牌"; //获取品牌名
    this.kpiUserName = localStorage.getItem("kpiRealName") || ""; //获取KPI用户的注册姓名
    this.actName = localStorage.getItem("actName") || ""; //获取活动名
    this.getQueryBonusSettingDetail();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取当前活动的充值设置
    async getQueryBonusSettingDetail() {
      let res = await this.$http.post(
        `/v1/pay/charge_config?role=${this.kpiUserType}`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        var detail = res.data;
        this.BrandDetail.brandBonusBean = detail.brandBonusBean;
        this.BrandDetail.staffBonusBean = detail.staffBonusBean;
        this.BrandDetail.brandPenalty = detail.brandPenalty;
        this.BrandDetail.userShareBonus = detail.userShareBonus;
        this.BrandDetail.staffSingleBonus = detail.staffSingleBonus;
        this.BrandDetail.liveRedPackage = detail.liveRedPackage;
        this.BrandDetail.otherPromotionExpenses = detail.otherPromotionExpenses;
        this.brand_total_bonus = Number(this.BrandDetail.brandBonusBean)
          .add(this.BrandDetail.staffBonusBean)
          .add(this.BrandDetail.brandPenalty)
          .add(this.BrandDetail.userShareBonus)
          .add(this.BrandDetail.staffSingleBonus)
          .add(this.BrandDetail.liveRedPackage)
          .add(this.BrandDetail.otherPromotionExpenses);
        this.staffBonus = detail.staffBonus;
        if (this.brand_total_bonus == 0 && this.kpiUserType == "brand") {
          localStorage.setItem("BrandBonus", 0);
          this.$router.push({
            name: "kpi.home",
            query: {
              act_id:
                this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
        } else if (this.staffBonus == 0 && this.kpiUserType == "staff") {
          localStorage.setItem("StaffBonus", 0);
          this.$router.push({
            name: "kpi.home",
            query: {
              act_id:
                this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
        }
      }
    },
    // 根据活动ID获取品牌列表
    getAllBrands() {
      this.$http
        .post("/v1/home/brand/list", {
          // actId: this.confirmDetail.actId,
          actId: localStorage.getItem("act_id") || 0,
          name: "",
          page: -1,
          size: -1,
        })
        .then((res) => {
          this.brandList = res.data.list;
          this.brandList.forEach();
        });
    },
    // 微信充值
    async createCharge() {
      var amount = 0;
      if (this.kpiUserType == "brand") {
        amount = this.brand_total_bonus;
      } else if (this.kpiUserType == "staff") {
        amount = this.staffBonus;
      } else {
        this.$toast("非法角色，充值失败！");
        return;
      }
      this.chargeDetail = {
        amount: null, //充值金额（元）,品牌单独充值的时候传
        chargeUserType: this.kpiUserType, //充值用户类型：staff：导购员，brand：品牌方，finance：财务单独充
        type: null, //首次充值时不传，品牌单独充值时传
        //充值类型,当chargeUserType=finance时，需要传。brand_bonus_bean：品牌奖励豆奖金池，staff_bonus_bean：导购员奖励豆奖金池，brand_penalty：品牌惩罚承诺金，user_share_bonus：客户分享奖励，staff_single_bonus：导购员单项奖励金，live_red_package：直播间红包，other_promotion_expenses：其他推广费用
      };
      let res = await this.$http.post(
        `/v1/pay/create_charge`,
        this.chargeDetail
      );
      console.log(res);
      if (res.data && res.code == 0) {
        let tmp = {
          appId: res.data.appId, //公众号名称，由商户传入
          nonceStr: res.data.nonceStr, //随机串
          package: res.data.packageValue, //
          paySign: res.data.paySign, //微信签名
          signType: res.data.signType, //微信签名方式：
          timeStamp: res.data.timeStamp, //时间戳，自1970年以来的秒数

          // totalFee: res.data.totalFee, //本次充值支付金额(元)
          // tradeNo: res.data.tradeNo, //本次充值订单号
        };
        // tmp对象暂未确认，等待修改
        console.log(tmp);
        this.wechatPay(tmp);
      } else if (res.code == 20723) {
        // 充值成功后，跳转到首页
        this.$router.push({
          name: "kpi.home",
          query: {
            activity_id: this.activity.id,
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }
    },
    wechatPay(json) {
      console.log(json);
      const that = this;
      try {
        console.log(typeof WeixinJSBridge);
        if (typeof WeixinJSBridge !== "undefined") {
          WeixinJSBridge.invoke("getBrandWCPayRequest", json, (res) => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              // that.$toast("支付成功！");
              // setTimeout(() => {
              //   this.$router.push({
              //     name: "kpi.home",
              //   });
              // }, 5000);
              that.$toast("支付成功！");
              that.$router.push({
                name: "kpi.home",
                query: {
                  act_id:
                    this.$route.query.act_id || localStorage.getItem("act_id"),
                },
              });
            }
          });
        } else {
          that.$toast("请使用微信支付");
        }
      } catch (e) {
        that.$toast("服务器繁忙，请稍后再试");
      }
    },
    // 充值操作
    async saveBrandCharge() {
      let res = await this.$http.post(
        `/v1/kpiuser/brand_charge`,
        this.BrandDetail
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("充值成功！");
        // 此时跳转到KPI首页
        this.$router.push({
          name: "kpi.home",
          query: {
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }
    },
    // 导购员充值操作
    async saveStaffCharge() {
      let res = await this.$http.post(`/v1/kpiuser/kpi_user_charge`, {
        amount: Number(this.staffBonus),
        type: "staff_bonus",
      });
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("充值成功！");
        // 此时跳转到KPI首页
        this.$router.push({
          name: "kpi.home",
          query: {
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }
    },

    getKpi() {
      this.$fn.get("kpi/settings", { activity_id: this.activity.id }, (res) => {
        this.kpi = res.data;
        this.brand_total_bonus =
          Number(this.kpi.kpi_brand_fee) +
          Number(this.kpi.kpi_staff_brand_fee) +
          Number(this.kpi.kpi_promise_fee) +
          Number(this.kpi.kpi_spread_fee) +
          Number(this.kpi.kpi_live_fee);
      });
    },
    getUser() {
      this.$fn.showLoading();
      this.$fn.get("user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "success") {
          this.live_user = res.data;
        }
        this.getKpiUser();
      });
    },
    getKpiUser() {
      this.$fn.showLoading();
      this.$fn.get("kpi/user", { activity_id: this.activity.id }, (res) => {
        this.$fn.closeLoading();
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        if (res.status === "success") {
          this.user = res.data;
          if (this.user.recharged) {
            // 充值成功后，跳转到首页
            this.$router.push({
              name: "kpi.home",
              query: {
                activity_id: this.activity.id,
                act_id:
                  this.$route.query.act_id || localStorage.getItem("act_id"),
              },
            });
          } else {
            if (this.user.type === 2) {
              this.role = "品牌负责人";
            } else if (this.user.type === 3) {
              this.role = "导购员";
            }
          }
        }
        this.$fn.commonShare(this.activity, this.live_user, this.user);
      });
    },
    /**
     * 确认充值
     */
    recharge() {
      this.$fn.showLoading();
      this.$fn.post("recharges", { activity_id: this.activity.id }, (res) => {
        this.$fn.closeLoading();
        if (res.status === "error") {
          return this.$fn.toast(res.msg);
        }
        if (res.status === "success") {
          this.wechatPay(res.json);
        }
      });
    },
    /**
     * 微信支付
     * @param jsonStr
     */
    // wechatPay(jsonStr) {
    //   try {
    //     const json = JSON.parse(jsonStr);
    //     if (typeof WeixinJSBridge !== "undefined") {
    //       WeixinJSBridge.invoke("getBrandWCPayRequest", json, (res) => {
    //         if (res.err_msg === "get_brand_wcpay_request:ok") {
    //           this.$fn.success("充值成功!", () => {
    //             this.$router.push({
    //               name: "kpi.home",
    //               query: { activity_id: this.activity.id, flag_recharge: true },
    //             });
    //           });
    //         }
    //       });
    //     } else {
    //       this.$fn.toast("请使用微信支付");
    //     }
    //   } catch (e) {
    //     this.$fn.toast("服务器繁忙，请稍后再试");
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.kpi-recharge-page {
  font-size: 14px;
  .title {
    /*头部*/
    background-color: #ffffff;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    flex: 1;
    font-weight: bold;
    img {
      width: 90px;
      height: 90px;
    }
    div {
      width: 56%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      padding-top: 10px;
    }
  }
  .tip {
    font-weight: bold;
    padding: 10px 15px;
  }

  .cell-group {
    .btn {
      justify-content: space-between;
      .amount {
        color: #5293fd;
      }
      .van-button--small {
        height: 22px;
        line-height: 20px;
      }
    }
    .tips {
      font-size: 12px;
      padding: 10px 15px;
      color: #f93e3e;
    }
  }
}
</style>
